"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var Tasks_consts_1 = require("../../Task/Tasks.consts");
var runs_consts_1 = require("../runs.consts");
var RunStore = /** @class */ (function (_super) {
    __extends(RunStore, _super);
    function RunStore(session) {
        var _this = _super.call(this, { session: session, entityName: 'runs' }) || this;
        _this.createRun = function (payload) {
            return _this.createOrUpdateRun(payload, _this.onCreate.bind(_this));
        };
        _this.updateRun = function (payload) {
            return _this.createOrUpdateRun(payload, _this.onUpdate.bind(_this));
        };
        _this.createOrUpdateRun = function (payload, callback) {
            var existingRunModel = _this.store.getItem(payload.run.id);
            var updatedRunModel = { id: payload.run.id, run: payload.run, taskIds: undefined };
            if (existingRunModel) {
                updatedRunModel.taskIds = existingRunModel.taskIds;
            }
            else {
                updatedRunModel.taskIds = _this.taskIdsWaitingForRun.get(payload.run.id) || new Set();
                _this.taskIdsWaitingForRun.delete(payload.run.id);
            }
            _this.storeItem(updatedRunModel);
            callback(_this.store.getItem(payload.run.id));
        };
        _this.deleteRun = function (payload) {
            var runModel = _this.store.getItem(payload.id);
            _this.store.removeFromStore(payload.id);
            _this.onDelete(runModel);
        };
        _this.updateTaskIdsOnDelete = function (task) {
            var existingRunModel = _this.store.getItem(task.run_id);
            if (!existingRunModel) {
                return;
            }
            existingRunModel.taskIds.delete(task.id);
            _this.updateRun(existingRunModel);
        };
        _this.updateTaskIds = function (task) {
            var runId = task.run_id || _this.taskIdToRunId.get(task.id);
            var existingRunModel = _this.store.getItem(runId);
            if (!existingRunModel) {
                _this.backupTasksUntilRunIsCreated(task);
            }
            else if (_this.taskAddedToRun(task, existingRunModel)) {
                existingRunModel.taskIds.add(task.id);
                _this.updateRun(existingRunModel);
            }
            else if (_this.taskRemovedFromRun(task, existingRunModel)) {
                existingRunModel.taskIds.delete(task.id);
                _this.updateRun(existingRunModel);
            }
            _this.updatePreviousRun(task);
            _this.taskIdToRunId.set(task.id, task.run_id);
        };
        _this.taskIdsWaitingForRun = new Map();
        _this.taskIdToRunId = new Map();
        return _this;
    }
    RunStore.prototype.attachSubscriptions = function () {
        if (this.subscribedToRealtime) {
            return;
        }
        this.subscribedToRealtime = true;
        this.realTime.on(runs_consts_1.RunEvents.CREATED, this.createRun);
        this.realTime.on(runs_consts_1.RunEvents.UPDATED, this.updateRun);
        this.realTime.on(runs_consts_1.RunEvents.DELETED, this.deleteRun);
        this.realTime.on(Tasks_consts_1.TaskRealTimeEvents.TASK_DELETED, this.updateTaskIdsOnDelete);
        this.realTime.on(Tasks_consts_1.TaskRealTimeEvents.TASK_UPDATE, this.updateTaskIds);
        this.realTime.on(Tasks_consts_1.TaskRealTimeEvents.NEW_TASK, this.updateTaskIds);
    };
    RunStore.prototype.set = function (run) {
        return this.setAll([run])[0];
    };
    RunStore.prototype.setAll = function (runs) {
        var e_1, _a;
        var _this = this;
        var runModels = runs.map(function (run) {
            var _a;
            return ({
                id: run.id,
                run: run,
                taskIds: new Set(run.task_ids || ((_a = run.tasks) === null || _a === void 0 ? void 0 : _a.map(function (task) { return task.id; })))
            });
        });
        var _loop_1 = function (runModel) {
            runModel.taskIds.forEach(function (taskId) {
                _this.taskIdToRunId.set(taskId, runModel.id);
            });
        };
        try {
            for (var runModels_1 = __values(runModels), runModels_1_1 = runModels_1.next(); !runModels_1_1.done; runModels_1_1 = runModels_1.next()) {
                var runModel = runModels_1_1.value;
                _loop_1(runModel);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (runModels_1_1 && !runModels_1_1.done && (_a = runModels_1.return)) _a.call(runModels_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.storeAllItems(runModels);
        return runModels;
    };
    RunStore.prototype.updatePreviousRun = function (task) {
        var previousRunId = this.taskIdToRunId.get(task.id);
        if (previousRunId && previousRunId != task.run_id) {
            if (this.taskIdsWaitingForRun.has(previousRunId)) {
                this.taskIdsWaitingForRun.get(previousRunId).delete(task.id);
            }
            var previousRunModel = this.store.getItem(previousRunId);
            if (previousRunModel) {
                previousRunModel.taskIds.delete(task.id);
                this.updateRun(previousRunModel);
            }
        }
    };
    RunStore.prototype.taskRemovedFromRun = function (task, existingRunModel) {
        return !task.run_id && existingRunModel.taskIds.has(task.id);
    };
    RunStore.prototype.taskAddedToRun = function (task, existingRunModel) {
        return task.run_id && !existingRunModel.taskIds.has(task.id);
    };
    RunStore.prototype.backupTasksUntilRunIsCreated = function (task) {
        if (!task.run_id) {
            return;
        }
        if (!this.taskIdsWaitingForRun.has(task.run_id)) {
            this.taskIdsWaitingForRun.set(task.run_id, new Set());
        }
        this.taskIdsWaitingForRun.get(task.run_id).add(task.id);
    };
    return RunStore;
}(StoreEntity_1.default));
exports.default = RunStore;
//# sourceMappingURL=RunStore.js.map